<template>
  <div class="body">
    <div class="title">
      <template v-if="isMySelf">基本信息</template>
      <template v-else>查看入驻详情</template>

      <!-- 面包屑导航区域 -->
      <div v-if="isMySelf" class="fansk">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/shouye' }"
            ><span class="dsadf"> 首页 </span></el-breadcrumb-item
          >
          <el-breadcrumb-item>基本信息</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div v-else class="fansk">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/shouye' }"
            ><span class="dsadf"> 首页 </span></el-breadcrumb-item
          >
          <el-breadcrumb-item class="dsadf" :to="{ path: '/shangxiehuiguanli' }"
            >社团管理</el-breadcrumb-item
          >
          <el-breadcrumb-item>查看详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>

    <div style="margin: -20px 0 20px">
      <el-button v-if="!isMySelf" size="mini" @click="$router.back()"
        >返回</el-button
      >
    </div>

    <el-card class="cardpsad">
      <div v-if="isMySelf" class="btn-wrap">
        <!-- <el-button type="primary" size="mini" @click="chengyuanliebiao">成员列表</el-button> -->
        <el-button
          type="primary"
          size="medium"
          @click="handleRouterEdit"
          style="font-size: 24px"
          >编辑</el-button
        >
      </div>

      <el-row>
        <el-col :span="12">
          <div class="fromdsadas">
            <div class="tiile">基本信息</div>
            <div>
              <el-form class="demo-form-inline" :label-position="labelPosition">
                <el-form-item label="协会名称" label-width="116px">
                  {{ Query.org_com }}
                </el-form-item>
                <el-form-item label="协会二维码" label-width="116px">
                  <div style="display: flex">
                    <!-- <div
                      style="
                        width: 120px;
                        display: flex;
                        flex-direction: column;
                        margin-right: 8px;
                      "
                    >
                      <el-image
                        v-if="qrcodeUrl"
                        style="width: 120px; height: 120px"
                        :src="qrcodeUrl"
                      >
                      </el-image>
                      <el-button size="mini " @click="handleDown">
                        下载社团二维码
                      </el-button>
                    </div> -->
                    <div style="display: flex; flex-direction: column">
                      <el-image
                        style="width: 120px; height: 120px"
                        :src="qrcodeUrl2"
                      >
                      </el-image>
                      <el-button size="mini " @click="handleDown2">
                        下载社团小程序码
                      </el-button>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="协会LOGO" label-width="116px">
                  <img :src="Query.org_logo" alt="" class="imgscc" />
                </el-form-item>
                <el-form-item label="营业执照" label-width="116px">
                  <img :src="Query.org_license" alt="" class="imgscc" />
                </el-form-item>
                <el-form-item label="赛事级别" label-width="116px">
                  {{ Query.act_level_text }}
                </el-form-item>
                <el-form-item label="社团地址" label-width="116px">
                  {{ Query.org_areaname }} {{ Query.org_town_name || "" }}
                  {{ Query.org_address }}
                </el-form-item>
                <el-form-item label="协会介绍" label-width="116px">
                  <div class="wenbenyu">
                    {{ Query.org_remark }}
                  </div>
                </el-form-item>
                <el-form-item label="主页背景" label-width="116px">
                  <img :src="Query.org_bgpic" alt="" class="imgscc" />
                </el-form-item>
              </el-form>
            </div>
            <!-- <div class="rou">
              <button  @click="tongguoshenqing()" icon="el-icon-delete" class="tongguo" >
                <i class="el-icon-check"></i>
                通过申请</button>
              <button  @click="Pushjujue()" icon="el-icon-delete" class="jujue">
                <i class="el-icon-close mb"></i>
                拒绝申请</button>
            </div> -->
          </div>
        </el-col>
        <el-col :span="12">
          <div class="fromdsadas">
            <div class="tiile">申请人信息</div>
            <el-form class="demo-form-inline" :label-position="labelPosition">
              <el-form-item label="申请人姓名 " label-width="116px">
                {{ Query.apply_realname }}
              </el-form-item>
              <el-form-item label="申请人手机号" label-width="116px">
                {{ Query.apply_mobile }}
              </el-form-item>
              <el-form-item label="活动类型">
                {{ Query.sport_type_text }}
              </el-form-item>
              <el-form-item label="活动场地" v-if="Query.site_type_text">
                {{ Query.site_type_text }}
              </el-form-item>
            </el-form>
            <div class="tiile">申请信息</div>
            <el-form class="demo-form-inline" :label-position="labelPosition">
              <el-form-item label="申请时间 " label-width="116px">
                {{ Query.apply_time }}
              </el-form-item>
              <!-- <el-form-item label="审核时间" label-width="116px">
                {{Query.status_time }}
              </el-form-item> -->
            </el-form>
            <div class="tiile">状态信息</div>
            <el-form class="demo-form-inline" :label-position="labelPosition">
              <el-form-item label="上架状态" label-width="116px">
                <span
                  :style="{
                    color: Query.is_status === 0 ? '#F7D05C' : '#17ab3f',
                  }"
                >
                  {{ Query.is_status === 0 ? "未上架" : "已上架" }}
                </span>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
      </el-row>
      <el-row :span="24">
        <div class="fromdsadas">
          <div>
            <el-form :label-position="labelPosition">
              <el-col :span="12">
                <el-form-item label="发证机关" label-width="116px">
                  {{ Query.issuing_authority }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="法人" label-width="116px">
                  {{ Query.legal_person }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="信用代码" label-width="116px">
                  {{ Query.credit_code }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="成立日期" label-width="116px">
                  {{ Query.created_date }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="注册住所" label-width="116px">
                  <div class="wenbenyu">
                    {{ Query.reg_address }}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="证书有效日期" label-width="116px">
                  {{ Query.cert_valid_start }} - {{ Query.cert_valid_end }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="注册资金" label-width="116px">
                  <div class="wenbenyu">{{ Query.reg_capital }}元</div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="主管单位" label-width="116px">
                  <div class="wenbenyu">
                    {{ Query.organizer }}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="评估等级" label-width="116px">
                  <div class="wenbenyu">
                    {{ Query.eva_level }}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="是否慈善组织" label-width="116px">
                  <div class="wenbenyu">
                    {{ Query.is_charitable === 1 ? "是" : "否" }}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="是否支援组织" label-width="116px">
                  <div class="wenbenyu">
                    {{ Query.is_support === 1 ? "是" : "否" }}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="是否获取公募资格" label-width="130px">
                  <div class="wenbenyu">
                    {{ Query.is_public_equity === 1 ? "是" : "否" }}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="业务范围" label-width="116px">
                  <div class="wenbenyu">
                    {{ Query.business_scope }}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="组织架构" label-width="116px">
                  <div class="wenbenyu">
                    {{ Query.organization }}
                  </div>
                </el-form-item>
              </el-col>
            </el-form>
          </div>
        </div>
      </el-row>
    </el-card>
    <vxe-modal
      width="336"
      ref="tongguo"
      height="182"
      size="small"
      :show-footer="false"
      :showHeader="false"
      :show-close="true"
    >
      <div class="popchuangkou">
        <img
          src="../../assets/img/closeaaaa.png"
          alt=""
          class="dsff"
          @click="routeClose"
        />
        <div class="titledd">是否确认通过申请?</div>
        <div class="bobox">
          <button class="queren" @click="openqueren">确认</button>
          <button class="quxiao" @click="routeClose">取消</button>
        </div>
      </div>
    </vxe-modal>
    <vxe-modal
      width="336"
      ref="jujue"
      height="202"
      size="small"
      :show-footer="false"
      :showHeader="false"
      :show-close="true"
    >
      <div class="popchuangkou">
        <img
          src="../../assets/img/closeaaaa.png"
          alt=""
          class="dsff"
          @click="routeClosecc"
        />
        <div class="titledd mbP">是否确认通过申请?</div>
        <vxe-input v-model="remark" placeholder="请输入拒绝理由"></vxe-input>
        <div class="bobox">
          <button class="queren" @click="openjujue">确认</button>
          <button class="quxiao" @click="routeClosecc">取消</button>
        </div>
      </div>
    </vxe-modal>

    <Chengyuanliebiao ref="Chengyuanliebiao" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import QRcode from "qrcode";
import { downloadFile } from "@/utils";

import Chengyuanliebiao from "../shangxiehuiguanli/components/Chengyuanliebiao";
import { getMiniAppQrcode } from "@/api/huodongguanliBaomingjilu";

import { setapply, shangxiehuixiangqing } from "@/api/shangxiehui";
export default {
  name: "index",
  components: { Chengyuanliebiao },
  computed: {
    // ...mapState(["shangxiehuixiangqing"]),
    isMySelf() {
      return !this.shangxiehuixiangqing && this.Query.id;
    },
  },
  created() {
    this.shangxiehuixiangqing = this.$route.query.id || "";
    this.xiangqing();
  },
  data() {
    return {
      qrcodeUrl: "",
      qrcodeUrl2: "",
      labelPosition: "left",
      Query: {},
      pic: [],
      remark: "",
    };
  },
  methods: {
    handleDown() {
      downloadFile(`${this.Query.org_com}二维码.png`, this.qrcodeUrl);
    },
    handleDown2() {
      downloadFile(`${this.Query.org_com}小程序码.png`, this.qrcodeUrl2, true);
    },
    handleRouterEdit() {
      this.$router.push(
        `/AddXiehui?id=${this.Query.id}&source=mass_organizations_self`
      );
    },
    openjujue() {
      const obj = {
        token: sessionStorage.getItem("token"),
        ids: this.shangxiehuixiangqing,
        apply_type: 2,
        apply_remark: this.remark,
      };
      setapply(obj).then(({ data: res }) => {
        console.log("res", res);
        if (res.result === -1) {
          this.$message({
            message: res.msg,
            type: "error",
            duration: "2000",
          });
          setTimeout(() => {
            window.sessionStorage.clear();
            this.$router.push("/login");
          }, 1000);
        }
        if (res.result === 0) {
          this.$message({
            message: res.msg,
            type: "error",
            duration: "2000",
          });
          return false;
        }
        if (res.result === 1) {
          this.$message({
            message: res.msg,
            type: "success",
            duration: "2000",
          });
          this.$refs.jujue.close();
          this.xiehuiList();
        }
      });
    },
    openqueren() {
      const obj = {
        token: sessionStorage.getItem("token"),
        ids: this.shangxiehuixiangqing,
        apply_type: 1,
      };
      setapply(obj).then(({ data: res }) => {
        console.log("res", res);
        if (res.result === -1) {
          this.$message({
            message: res.msg,
            type: "error",
            duration: "2000",
          });
          setTimeout(() => {
            window.sessionStorage.clear();
            this.$router.push("/login");
          }, 1000);
        }
        if (res.result === 0) {
          this.$message({
            message: res.msg,
            type: "error",
            duration: "2000",
          });
          return false;
        }
        if (res.result === 1) {
          this.$message({
            message: res.msg,
            type: "success",
            duration: "2000",
          });
          this.$refs.tongguo.close();
          this.xiehuiList();
        }
      });
    },
    tongguoshenqing() {
      this.$refs.tongguo.open();
    },
    routeClose() {
      this.$refs.tongguo.close();
    },
    Pushjujue() {
      this.$refs.jujue.open();
    },
    routeClosecc() {
      this.$refs.jujue.close();
    },
    async initQrImage(text) {
      if (text) {
        return QRcode.toDataURL(text);
      }
      const resultResp = await getMiniAppQrcode({
        path: "pages/sportsCode/qrCodeRecognition",
        env: "release",
        scene: `p=2_${this.Query.id}`,
      });
      console.log("_initQrImage", resultResp);
      return Promise.resolve(resultResp.data.data.url);
    },
    xiangqing() {
      const obj = {
        token: sessionStorage.getItem("token"),
        id: this.shangxiehuixiangqing || "",
      };
      shangxiehuixiangqing(obj).then(async ({ data: res }) => {
        if (res.organization) {
          // console.log("_res.organization", res.organization)
          res.organization = res.organization.split("\n").join("; ");
        }

        console.log("_res", res);

        this.Query = res;
        this.pic = res.org_pics;
        console.log("this.pic", this.pic);

        try {
          // 根据 url 生成二维码
          const qrcodeUrl = await this.initQrImage(res.url);
          const qrcodeUrl2 = await this.initQrImage();
          this.qrcodeUrl = qrcodeUrl;
          this.qrcodeUrl2 = qrcodeUrl2;
        } catch (error) {
          console.error("二维码生成失败");
        }
      });
    },

    chengyuanliebiao() {
      this.$refs.Chengyuanliebiao.handleOpenDialog({
        id: this.Query.id,
      });
    },
  },
};
</script>

<style scoped lang="less">
.popchuangkou {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  .mbP {
    margin-bottom: 24px;
  }
  .dsff {
    position: absolute;
    right: 0;
    top: 0;
    width: 20px;
    height: 20px;
  }
  .titledd {
    margin-top: 22px;
    font-size: 18px;
    font-family: PingFang SC, PingFang SC-Bold;
    font-weight: 500;
    text-align: left;
    color: #2e2e2e;
  }
  .einput {
    width: 253px;
    height: 44px;
    opacity: 1;
    background: #fbfbfb;
    border-radius: 5px;
  }
  .bobox {
    margin-top: 43px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .queren {
    width: 95px;
    height: 36px;
    opacity: 1;
    background: linear-gradient(135deg, #3d9aff, #3380f2);
    border-radius: 2px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: left;
    color: #ffffff;
    letter-spacing: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    margin-right: 12px;
  }
  .quxiao {
    width: 95px;
    height: 36px;
    opacity: 1;
    background: rgba(61, 154, 255, 0.1);
    border-radius: 2px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: left;
    color: #3d9aff;
    letter-spacing: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
  }
}
.tongguo {
  width: 124px;
  height: 44px;
  opacity: 1;
  background: linear-gradient(135deg, #1bb745, #17ab3f);
  border-radius: 5px;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  letter-spacing: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  border: none;
}
.mb {
  margin-right: 10px;
}
.jujue {
  border: none;
  width: 124px;
  height: 44px;
  opacity: 1;
  background: linear-gradient(135deg, #e54848, #d54141);
  border-radius: 5px;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
  letter-spacing: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}
.rou {
  display: flex;
  flex-direction: row;
}
.fxrowccsaa {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  width: 400px;
  .imgsccccss {
    width: 100px;
    height: 100px;
    margin-right: 20px;
    margin-bottom: 20px;
    display: inline-block;
    .imgscc33 {
      width: 100%;
      height: 100%;
    }
  }
}
.imgscc {
  width: 100px;
  height: 100px;
}
.body {
  display: flex;
  flex-direction: column;
  .cardpsad {
    position: relative;
    padding: 5px 50px 40px;
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;

    .btn-wrap {
      position: absolute;
      z-index: 10;
      right: 20px;
      top: 20px;
    }
  }
  .wenbenyu {
    width: 370px;
  }
  .title {
    opacity: 1;
    font-size: 30px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
    letter-spacing: 0px;
    margin-bottom: 35px;
    display: flex;
    flex-direction: row;
    align-items: center;

    .fansk {
      margin-top: 30px;
      margin-left: 32px;
    }

    .dsadf {
      color: #3d9aff;
    }
  }
  .fromdsadas {
    display: flex;
    flex-direction: column;
    .tiile {
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Heavy;
      font-weight: 800;
      text-align: left;
      color: #2e2e2e;
      letter-spacing: 0px;
      margin-bottom: 42px;
    }
  }
}
</style>
